import { useMainStore } from '@/store'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import { useToast } from 'vue-toastification'

import { apiBaseUrl as baseUrl } from './baseUrl'
// const baseUrl = 'http://localhost:8070'

const getClientTokenHeaders = () => {
  const token = VueCookies.get('client_token')
  return {
    client_token: token
  }
}

// 모든 권한 제한 함수
const hasPermission = () => {
  const store = useMainStore()
  const authorityData = store.authorityData // Pinia에 저장된 권한 데이터
  // console.log('hasPermission : authorityData:', authorityData)

  // adminLevel이 "admin"이면 권한 있음
  if (authorityData?.adminLevel === 'admin') {
    return true
  }

  // adminLevel이 "admin"이 아닐 경우 admin_role 값을 검사
  return authorityData?.admin_role === 1
}

// 토스트 메시지 표시 함수
const showCustomToast = (content, type) => {
  const toast = useToast()
  const customToastOptions = {
    position: 'top-center',
    timeout: 2504,
    closeOnClick: false,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    draggable: false,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: false,
    icon: true,
    rtl: false
  }

  switch (type) {
    case 'error':
      toast.error(content, customToastOptions)
      break
    case 'info':
      toast.info(content, customToastOptions)
      break
    case 'warning':
      toast.warning(content, customToastOptions)
      break
    default:
      toast.info(content, customToastOptions)
      break
  }
}

// 스케줄링 데이터를 포함한 차량 목록 출력
const scheduleList = () => {
  return axios.get(`${baseUrl}/schedule/v1/car-list`, {
    headers: getClientTokenHeaders()
  })
}
// 스케줄링 유형 목록 출력
const schedulePresetList = () => {
  return axios.get(`${baseUrl}/schedule/v1/preset-list`, {
    headers: getClientTokenHeaders()
  })
}
// 단일 차량의 스케줄링 데이터 출력
const scheduleSingleData = (car_id) => {
  return axios.get(`${baseUrl}/schedule/v1/car/${car_id}`, {
    headers: getClientTokenHeaders()
  })
}
// 단일 차량의 스케줄링 데이터 출력 V2 (view_car_model_view_v2 기반)
const scheduleSingleDataV2 = (car_id) => {
  return axios.get(`${baseUrl}/schedule/v2/car/${car_id}`, {
    headers: getClientTokenHeaders()
  })
}
// 스케줄링 유형 목록 출력
const scheduleTypeList = () => {
  return axios.get(`${baseUrl}/getdata/v1/schedule-preset-list`, {
    headers: getClientTokenHeaders()
  })
}
// 스케줄링 프리셋 데이터 전체보기
const schedulePresetAll = (schedulePresetID) => {
  return axios.get(`${baseUrl}/getdata/v1/schedule-preset-all/${schedulePresetID}`, {
    headers: getClientTokenHeaders()
  })
}
// 단일 차량의 스케줄링 데이터 추가 ( 현재 사용 X )
// const scheduleRegister = (carData) => {
//   if (!hasPermission()) {
//     showCustomToast(
//       '부관리자 계정의 스케줄링 데이터 추가 기능이 제한되어 있습니다.\n자세한 사항은 관리자에게 문의해 주세요.',
//       'error'
//     )
//     return Promise.reject(new Error('스케줄링 데이터 추가 권한이 없습니다.'))
//   }
//   return axios.post(`${baseUrl}/schedule/v1/connection`, carData, {
//     headers: getClientTokenHeaders()
//   })
// }
// 단일 차량의 스케줄링 데이터 수정
// skipPermissionCheck: 호출측에서 이미 권한 검증 완료 시 true (CustomerCarsView 등)
const scheduleUpdate = (scheduleData, { skipPermissionCheck = false } = {}) => {
  if (!skipPermissionCheck && !hasPermission()) {
    showCustomToast(
      '부관리자 계정의 스케줄링 데이터 수정 기능이 제한되어 있습니다.\n자세한 사항은 관리자에게 문의해 주세요.',
      'error'
    )
    return Promise.reject(new Error('스케줄링 데이터 수정 권한이 없습니다.'))
  }
  return axios.put(`${baseUrl}/schedule/v1/connection`, scheduleData, {
    headers: getClientTokenHeaders()
  })
}
// 단일 차량의 스케줄링 데이터 삭제 ( 현재 사용 X )
// const scheduleDelete = (carData) => {
//   if (!hasPermission()) {
//     showCustomToast(
//       '부관리자 계정의 스케줄링 데이터 삭제 기능이 제한되어 있습니다.\n자세한 사항은 관리자에게 문의해 주세요.',
//       'error'
//     )
//     return Promise.reject(new Error('스케줄링 데이터 삭제 권한이 없습니다.'))
//   }
//   return axios.patch(`${baseUrl}/schedule/v1/disconnection`, carData, {
//     headers: getClientTokenHeaders()
//   })
// }
// 단일 차량의 제조사데이터 프로파일 수정
// skipPermissionCheck: 호출측에서 이미 권한 검증 완료 시 true (CustomerCarsView 등)
const scheduleProFileMOBD = (scheduleProFileData, { skipPermissionCheck = false } = {}) => {
  if (!skipPermissionCheck && !hasPermission()) {
    showCustomToast(
      '부관리자 계정의 제조사 데이터 프로파일 수정 기능이 제한되어 있습니다.\n자세한 사항은 관리자에게 문의해 주세요.',
      'error'
    )
    return Promise.reject(new Error('제조사 데이터 프로파일 수정 권한이 없습니다.'))
  }
  return axios.put(`${baseUrl}/schedule/v1/model`, scheduleProFileData, {
    headers: getClientTokenHeaders()
  })
}

export {
  scheduleList,
  schedulePresetList,
  scheduleSingleData,
  scheduleSingleDataV2,
  scheduleTypeList,
  schedulePresetAll,
  // scheduleRegister,
  scheduleUpdate,
  // scheduleDelete,
  scheduleProFileMOBD
}
